import React from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface ProfileImageUpdateModalProps {
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ProfileImageUpdateModal: React.FC<ProfileImageUpdateModalProps> = ({ isVisible, onCancel, onConfirm }) => {
  const { t } = useTranslation("member");

  if (!isVisible) {
    return null;
  }

  return (
    <div className="edit-modal-image">
      <div className="edit-modal-image-wrap">
        {/* Modal Header */}
        <div className="edit-modal-header">
          <h3>{t("members.profile.modal.updateProfileImage.title")}</h3>
          <button onClick={onCancel} className="cancel-modal">
            ×
          </button>
        </div>

        {/* Modal Body */}
        <div className="upload-modal-body">
          <p>{t("members.profile.modal.updateProfileImage.description")}</p>
          <ul>
            <li>{t("members.profile.modal.updateProfileImage.requirements.formats")}</li>
            <li>{t("members.profile.modal.updateProfileImage.requirements.fileSize")}</li>
            <li>{t("members.profile.modal.updateProfileImage.requirements.dimensions")}</li>
          </ul>
        </div>

        {/* Modal Footer */}
        <div className="upload-image-modal">
          <button onClick={onCancel} className="btn-cancel">
            {t("members.profile.modal.updateProfileImage.buttons.cancel")}
          </button>
          <button onClick={onConfirm} className="btn-preview">
            {t("members.profile.modal.updateProfileImage.buttons.chooseImage")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileImageUpdateModal;
